import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useGeneralSummaryReport from './useGeneralSummaryReport'
import useScreenWidth from './useScreenWidth'

function useShareActions(title: string, description: string, link: string, type: string, light: boolean, foreignId: number) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { handleClickGeneralSummaryReport } = useGeneralSummaryReport(3)

  const [anchorOp, setAnchorOp] = useState<null | HTMLElement>(null)
  const [openOptions, setOpenOptions] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)

  useEffect(() => {
    ;(function (d: any, s: any, id: any) {
      let js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }, [openOptions])

  const handleClickWhatsapp = () => {
    let tmpText = light
      ? t('share-header-whatsapp-text', {
          APP_NAME: import.meta.env.VITE_NAME
        }).replace(/ /g, '%20')
      : t('share-whatsapp-text', {
          type: t(type),
          APP_NAME: import.meta.env.VITE_NAME
        }).replace(/ /g, '%20')
    window.open(`https://wa.me/?text=${tmpText} ${title} ${encodeURIComponent(link)}`)
  }

  const handleCloseOptions = () => {
    setAnchorOp(null)
    setOpenOptions(false)
  }

  const handleCopyText = () => {
    navigator.clipboard.writeText(link)
    setOpenAlert(true)
  }

  const handleCloseAlert = () => {
    setOpenAlert(false)
  }

  const handleShareButton = (event: any) => {
    handleClickGeneralSummaryReport(foreignId)
    if (isMobile) {
      handleNavigatorShare()
    } else {
      setAnchorOp(event.currentTarget)
      setOpenOptions(true)
    }
  }

  const handleNavigatorShare = () => {
    const dataShare = {
      title: title ?? '',
      text: description ?? '',
      url: link ?? ''
    }
    if ('Navigator' in window && navigator.canShare(dataShare)) {
      navigator
        .share(dataShare)
        .then(() => console.log('Successful share'))
        .catch(error => {
          console.error('Error sharing', error)
        })
    } else {
      handleCopyText()
      console.error('Share not supported on this browser.')
    }
  }

  return {
    anchorOp,
    openAlert,
    openOptions,
    handleClickWhatsapp,
    handleShareButton,
    handleCloseOptions,
    handleCloseAlert,
    handleNavigatorShare
  }
}

export default useShareActions
